//TODO - CustomizedItemCreation with uniqueId - Notifications - clean up
import React, { useEffect } from 'react';
//Libraries
import { useForm } from 'react-hook-form';

//Context
import { AuthConsumer } from '../../../authContext';

//Request Related
import PackageConfigRepository from 'client-sdk/src/Repository/partner-packageconfig-repository';
//UI
import {
  Grid,
  Paper,
  Typography,
  FormControlLabel,
  Button,
  SvgIcon,
  Checkbox,
} from '@material-ui/core';
// import theme from '../../theme';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import ConfigCard from './components/configCard';
import {
  dsiPackageCatalogue,
  dsiPackageBizCard,
  dsiPackageLabel,
  dsiPackageGift,
  dsiPackageDiscountCard,
  dsiInfo,
} from '../../../components/icons/customIcons';
import { CustomizedItems, PackageConfig } from '../interfaces';
import handleNotfication from '../../../utils/handleNotfication';
import handleError from '../../../utils/handleError';
import { mdiAlertOctagonOutline } from '@mdi/js';
import Icon from '@mdi/react';
//Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    //Aryan
    shadow: {
      position: 'relative',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        boxShadow: '0px 3px 24px rgba(0, 0, 0, 0.06)',
        transform: 'rotate(-180deg)',
      },
    },
    checkboxLabel: {
      fontWeight: 400,
      fontSize: '13px',
    },
    paper: {},
    loading: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },

    pagination: {
      // marginTop: theme.spacing(1),
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 480px)': {
        fontSize: '12px',
      },
    },
    cards: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
    },
    boxshadow: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
      transform: 'translateY(-3px)',
      boxShadow: '-6px 6px 14px 0px rgba(0,0,0,0.15) !important',
    },
    iconHeader: {
      position: 'absolute',
      top: '5px',
      right: '5px',
    },
    cardContent: {
      marginTop: '-22px',
      display: 'flex',
    },
    cardContentlist: {
      justifyContent: 'space-between',
      padding: ' 0',
    },
    hover: {
      '&:hover': {
        curser: 'pointer',
      },
    },
    mdiDresserIcon: {
      color: '#329926',

      // backgroundColor: '#D6EBD3',
    },
    mdiClipboardMultipleOutlineIcon: {
      color: '#6276F7',
    },
    chart: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    progress: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      padding: '8px 24px 8px 50px',
      marginLeft: '-40px',
    },
    card: {
      width: '100%',
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px 0 0',
      paddingBottom: '0',
    },

    cardContentOrder: {
      padding: '0',
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    closeIcon: {
      color: '#EC4040',
      backgroundColor: '#F7B3B3',
      borderRadius: '5px',
      padding: '5px',
    },
    textArea: {
      width: '100%',
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      marginTop: '45px',

      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(1),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    btnBox: {
      marginTop: '5px',
      padding: '10px',
      display: 'flex',
      flexDirection: 'row-reverse',
      // width: '100%',
      '@media (max-width: 480px)': {
        display: 'none',
        flexDirection: 'column-reverse',
        width: '100%',
      },
    },
    titleBar: {
      padding: '8px 2px',
      width: '100%',
      borderRadius: '0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '@media (max-width: 480px)': {
        width: '100%',
        marginLeft: '-70px',

        marginTop: '55px',
        flexDirection: 'column',
        alignItem: 'center',
        fontSize: '12px',
      },
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
      '@media (max-width: 480px)': {
        marginLeft: '-5px',

        fontSize: '12px',
      },
    },
    mobile: {
      maxWidth: '120%',
      margin: '16px 0',
      '@media (max-width: 480px)': {
        marginTop: '140px',
      },
    },
  })
);

//Helpers

//Defined Types
type Inputs = {
  packageChoice: string;
};

const PackagingPreferences = (props: {}) => {
  const {
    handleSubmit,
  } = useForm<Inputs>();
  const [packageChoice, setPackageChoice] = React.useState<string | undefined>(
    undefined
  );

  const [editMode, setEditMode] = React.useState<boolean>(false);

  const [packageConfigData, setPackageConfigData] = React.useState<
    PackageConfig | undefined
  >(undefined);
  const [packageConfigHistory, setPackageConfigHistory] = React.useState<
    PackageConfig | undefined
  >(undefined);
  const [customizedItems, setCustomizedItems] = React.useState<CustomizedItems[]>([]);

  useEffect(() => {
    pageInitialization();
  }, []);

  useEffect(() => {
    if (packageConfigData) {
      splitData(packageConfigData);
    }
  }, [packageConfigData]);


  const onSubmit = data => {
    setEditMode(false);
    //Check if if first time -> create if first time, update otherwise
    const payloadPackageConfig: PackageConfig = packageConfigData;
    payloadPackageConfig.customizedItems = customizedItems;
    payloadPackageConfig.packageType = packageChoice as string;
    updateMyPackageConfig(payloadPackageConfig);
  };

  //Radio handleChange
  const handleChange = event => {
    setPackageChoice(event.target.value);
  };

  //Changes coming from the child component ConfigCard
  const handleCardChanges = (data: CustomizedItems) => {
    const index = customizedItems.findIndex(i => i.id === data.id);
    setCustomizedItems([...customizedItems.slice(0, index), data, ...customizedItems.slice(index + 1)]);
  };

  //For each CustomizedItemType, add them:
  const handleCustomizedItemCreation = (name: string, type: any) => {
    const templateItem: CustomizedItems = {
      id: packageConfigData?.id,
      active: false,
      customizedItemType: type,
      description: `created by ${localStorage.getItem('partnerId')}`,
      name: name,
    };
    const newlyCreatedItem = createNewCustomizedItem(templateItem);
    newlyCreatedItem
      .then(response => {
        setCustomizedItems(prev => [...prev, response])
      })
      .catch(error => {
        handleError(error);
      })
  };

  const updateMyPackageConfig = async (config: PackageConfig) => {
    const action = {
      payload: config,
    };
    try {
      const { data } = await PackageConfigRepository.updatePackageConfig(action);
      setPackageConfigData(data);
      handleNotfication('تنظیمات با موفقیت به روز رسانی شد', 'success');
    } catch (error) {
      handleError(error.response);
    }
  };

  //Async functions related to requests
  const createMyPackageConfig = async (config: PackageConfig) => {
    const action = {
      payload: config,
    };
    try {
      const { data } = await PackageConfigRepository.createPackageConfig(action);
      setPackageConfigData(data);
    } catch (error) {
      setPackageConfigData({
        customizedForAll: true,
        customizedItems: [],
        packageType: 'RONAD',
        partnerId: localStorage.getItem('partnerId'),
      })
      handleError(error.response)
    }
  }
  const createNewCustomizedItem = async (item: CustomizedItems) => {
    const action = {
      payload: item,
      id: packageConfigData?.id,
    };
    try {
      const { data } = await PackageConfigRepository.createCustomizedItem(action);
      if (data) {
        handleNotfication('محتوای سفارشی به لیست اضافه شد', 'success');
        return data;
      } else {
        return null;
      }
    } catch (error) {
      handleError(error);
    }
  };

  const classes = useStyles();

  const handleEditMode = () => {
    setEditMode(true);
  };

  //Request Related
  const pageInitialization = async () => {
    const action = {
      payload: {
        id: localStorage.getItem('partnerId'),
      },
    };
    try {
      const { data } = await PackageConfigRepository.getPackageConfigById(action);
      setPackageConfigData(data);
      setPackageConfigHistory(data);
    } catch (error) {
      let initialConfig: PackageConfig = {
        customizedForAll: true,
        customizedItems: [],
        packageType: 'RONAD',
        partnerId: localStorage.getItem('partnerId'),
      };
      createMyPackageConfig(initialConfig)
    }
  };

  const splitData = (config: PackageConfig) => {
    if (config) {
      setPackageChoice(config.packageType);
      if (config.customizedItems) {
        setCustomizedItems(config.customizedItems || []);
      }
    }
  };

  return (
    <AuthConsumer>
              
      {({ user }) => (
        <>
          <Typography variant="h6" component="h2">
            {'مدیریت بسته‌بندی'}
          </Typography>
          <form onSubmit={handleSubmit(onSubmit)} style={{ marginTop: "24px" }}>
            <div
              style={{
                backgroundColor: '#FFF',
                padding: '24px',
                borderRadius: "4px"
                // marginRight: '-44px',
              }}
            >
              <div
                style={{
                  backgroundColor: 'white',
                  // marginTop: '32px',
                  // paddingInline: '64px',
                }}
              >
                <Typography
                  style={{
                    fontSize: '20px',
                    fontWeight: '700',
                    marginBottom: '24px',
                  }}
                >
                  تنظیمات پیش‌فرض بسته‌بندی
                </Typography>
                <Paper
                  className={classes.shadow}
                  elevation={0}
                  style={{
                    padding: '24px',
                    // marginTop: '64px'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignContent: 'space-between',
                      flexWrap: 'wrap',
                      gap: '8px',
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="my-checkbox-group"
                          value="PARTNER"
                          checked={packageChoice === 'PARTNER'}
                          onChange={handleChange}
                          color="primary"
                          size="small"
                        />
                      }
                      label={
                        <Typography className={classes.checkboxLabel}>
                          استفاده از بسته‌بندی خودم{' '}
                        </Typography>
                      }
                      disabled={!editMode}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="my-checkbox-group"
                          value="RONAD"
                          checked={packageChoice === 'RONAD'}
                          onChange={handleChange}
                          color="primary"
                          size="small"
                        />
                      }
                      label={
                        <Typography className={classes.checkboxLabel}>
                          استفاده از بسته‌بندی روناد
                        </Typography>
                      }
                      disabled={!editMode}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="my-checkbox-group"
                          value="NO_PACKAGE"
                          checked={packageChoice === 'NO_PACKAGE'}
                          onChange={handleChange}
                          color="primary"
                          size="small"
                        />
                      }
                      label={
                        <Typography className={classes.checkboxLabel}>
                          بدون بسته‌بندی
                        </Typography>
                      }
                      disabled={!editMode}
                    />
                  </div>
                  <Grid container className='notif'>
                    <Icon
                        path={mdiAlertOctagonOutline}
                        size={.8}
                    />
                    <Typography style={{marginRight: "10px", fontSize: "14px"}}>
                      تنظیمات اعمال شده به‌صورت پیش‌فرض بر روی تمامی سفارشات
                      اعمال می‌شود.
                    </Typography>
                </Grid>
                </Paper>
              </div>
              {packageChoice !== 'NO_PACKAGE' && (
                <div
                  style={{
                    backgroundColor: 'white',
                    marginTop: '24px',
                    // paddingInline: '64px',
                  }}
                >
                  <div style={{ marginBottom: '24px' }}>
                    <Typography
                      style={{
                        fontSize: '20px',
                        fontWeight: '700',
                      }}
                    >
                      اقلام همراه بسته‌بندی
                    </Typography>
                  </div>
                  <Paper
                    elevation={0}
                    className={classes.shadow}
                    style={{
                      padding: '24px',
                    }}
                  >
                    <div
                      style={{
                        // minWidth: '80vw',
                        display: 'flex',
                        flexDirection: 'row',
                        flex: 1,
                        width: '100%',
                        flexGrow: 1,
                        alignContent: 'space-between',
                        justifyContent: 'space-between',
                        // marginTop: '24px',
                        flexWrap: 'nowrap',
                        gap: '54px',
                      }}
                    >
                      <ConfigCard
                        type="CATALOG"
                        iconPath={dsiPackageCatalogue}
                        title="کاتالوگ و بروشور"
                        editMode={editMode}
                        data={customizedItems}
                        handleCardChanges={handleCardChanges}
                        handleCustomizedItemCreation={
                          handleCustomizedItemCreation
                        }
                      />

                      <ConfigCard
                        type="VISIT_CARD"
                        iconPath={dsiPackageBizCard}
                        title="کارت ویزیت"
                        editMode={editMode}
                        data={customizedItems}
                        handleCardChanges={handleCardChanges}
                        handleCustomizedItemCreation={
                          handleCustomizedItemCreation
                        }
                      />

                      <ConfigCard
                        type="BRANDED_LABEL"
                        iconPath={dsiPackageLabel}
                        title="لیبل"
                        editMode={editMode}
                        data={customizedItems}
                        handleCardChanges={handleCardChanges}
                        handleCustomizedItemCreation={
                          handleCustomizedItemCreation
                        }
                      />

                      <ConfigCard
                        type="GIFT_PACK"
                        iconPath={dsiPackageGift}
                        title="پک هدیه"
                        editMode={editMode}
                        data={customizedItems}
                        handleCardChanges={handleCardChanges}
                        handleCustomizedItemCreation={
                          handleCustomizedItemCreation
                        }
                      />

                      <ConfigCard
                        type="DISCOUNT_CARD"
                        iconPath={dsiPackageDiscountCard}
                        title="کارت تخفیف"
                        editMode={editMode}
                        data={customizedItems}
                        handleCardChanges={handleCardChanges}
                        handleCustomizedItemCreation={
                          handleCustomizedItemCreation
                        }
                      />
                    </div>
                    <Grid container className='notif'>
                      <Icon
                          path={mdiAlertOctagonOutline}
                          size={.8}
                      />
                      <Typography style={{marginRight: "10px", fontSize: "14px"}}>
                        با تعریف و انتخاب هر یک از دسته ‌بندی‌های فوق اقلام منتخب به همراه سفارش ارسال می‌شود.
                      </Typography>
                    </Grid>
                  </Paper>
                </div>
              )}
              <Grid
                style={{
                  backgroundColor: 'white',
                  // paddingInline: '64px',
                }}
              >
                <Paper
                  elevation={0}
                  style={{
                    // padding: '48px',
                    backgroundColor: 'transparent',
                  }}
                >
                  <div
                    style={{
                      minWidth: '80vw',
                      display: 'flex',
                      flexDirection: 'row',
                      alignContent: 'center',
                      justifyContent: 'end',
                      marginTop: '24px',
                      flexWrap: 'wrap',
                      gap: '8px',
                    }}
                  >
                    {!editMode && (
                      <Button
                        size="large"
                        //disabled={!packageConfigData}
                        variant="contained"
                        color="primary"
                        onClick={handleEditMode}
                      >
                        {'ویرایش'}
                      </Button>
                    )}
                    {editMode && (
                      <Button
                        size="large"
                        variant="contained"
                        color="primary"
                        type="submit"
                      >
                        {'اعمال تغییرات'}
                      </Button>
                    )}
                  </div>
                </Paper>
              </Grid>
            </div>
          </form>
        </>
      )}
    </AuthConsumer>
  );
};

export default PackagingPreferences;
